import { createContext, useContext } from "react";

export type TenantSetupDialogLifecycleContextValue = {
  closeDialog: () => void;
  openDialog: () => void;
};

export const TenantSetupDialogLifecycleContext =
  createContext<TenantSetupDialogLifecycleContextValue | null>(null);

export function useTenantSetupDialogLifecycleContext() {
  const context = useContext(TenantSetupDialogLifecycleContext);
  if (!context) {
    throw new Error(
      "useTenantSetupDialogLifecycleContext must be used within TenantSetupDialog",
    );
  }
  return context;
}
